import styled from 'styled-components';
import { NeutralColors } from 'theme';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding-bottom: 36px;
  width: 100%;
`;

const IllustrationWrapper = styled.div`
  width: 234px;
  height: 160px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
  max-width: 382px;
`;

const Title = styled.p`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  color: ${NeutralColors[100]};
  margin: 0;
`;

const Description = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: ${NeutralColors[90]};
  margin: 0;
`;

export {
  Content,
  Description,
  IllustrationWrapper,
  TextWrapper,
  Title,
  Wrapper,
};
